<script lang="ts">
    import type {Loan} from 'src/typings';
    import {getDateFormatter, getLocalization} from 'src/core';
    import {createEventDispatcher} from 'svelte';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import {exists} from 'shared/utils/custom-utils';
    import KpGenericPanel from 'shared/ui-widgets/panel/KpGenericPanel.svelte';

    export let loan: Loan;

    const dispatch = createEventDispatcher<{ 'select': void }>();
    const localize = getLocalization();
    const dateFormatter = getDateFormatter();
</script>

<button class="selectable-loan-card" on:click={() => dispatch('select')}>
    <KpGenericPanel additionalClasses="selectable-loan-card-panel">
        <svelte:fragment slot="heading">
            <span>{pipe(loan.state, loc())}</span>
            <span>#{loan.loanRealizationId}</span>
            <span> - {pipe(loan.document, loc())}</span>
        </svelte:fragment>

        <svelte:fragment>
            <div class="info-row">
                <span>Uživatel: </span>

                <a href="/#!/users/{loan.user.id}" target="_blank" data-qa="unprocessed-loan-user-name">
                    {pipe(loan.user, loc())}
                </a>
            </div>

            {#if exists(loan.exemplar)}
                {#if exists(loan.exemplar.accessNumber)}
                    <div class="info-row">
                        <small class="text-muted">
                            {localize(/* @kp-localization exemplar.AccessNumber.abbr */ 'exemplar.AccessNumber.abbr')}
                        </small>

                        <small>{loan.exemplar.accessNumber}</small>
                    </div>
                {/if}

                {#if exists(loan.exemplar.barCode)}
                    <div class="info-row">
                        <small class="text-muted">
                            {localize(/* @kp-localization exemplar.BarCode.abbr */ 'exemplar.BarCode.abbr')}
                        </small>

                        <small>{loan.exemplar.barCode}</small>
                    </div>
                {/if}

                {#if exists(loan.exemplar.signature)}
                    <div class="info-row">
                        <small class="text-muted">
                            {localize(/* @kp-localization exemplar.Signature.abbr */ 'exemplar.Signature.abbr')}
                        </small>

                        <small>{loan.exemplar.signature}</small>
                    </div>
                {/if}
            {/if}

            {#if exists(loan.department)}
                <div class="info-row">
                    <small class="text-muted">
                        {localize(/* @kp-localization department.Department.abbr */ 'department.Department.abbr')}
                    </small>

                    <small>{pipe(loan.department, loc())}</small>
                </div>
            {/if}

            {#if exists(loan.lendDate)}
                <div class="info-row">
                    <small class="text-muted">
                        {localize(/* @kp-localization loan.LoanDate.abbr */ 'loan.LoanDate.abbr')}
                    </small>

                    <small>{pipe(loan.lendDate, dateFormatter('d.M.yyyy'))}</small>
                </div>
            {/if}

            {#if exists(loan.endDate)}
                <div class="info-row">
                    <small class="text-muted">
                        {localize(/* @kp-localization loan.EndDate.abbr */ 'loan.EndDate.abbr')}
                    </small>

                    <small>{pipe(loan.endDate, dateFormatter('d.M.yyyy'))}</small>
                </div>
            {/if}
        </svelte:fragment>
    </KpGenericPanel>
</button>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .selectable-loan-card {
        outline: none;
        border: none;
        background: none;
        cursor: pointer;
        display: block;
        width: 100%;

        .info-row {
            display: flex;
            align-items: center;
            gap: @spacing-s;
        }
    }

    :global {
        .selectable-loan-card .selectable-loan-card-panel {
            margin-bottom: 0;

            .panel-body {
                display: flex;
                flex-direction: column;
                gap: @spacing-s;
            }
        }
    }
</style>